module.exports = __webpack_public_path__ + "static/media/kuibishan_web.a01ae7bb.webp";